import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';

const LoginPage = () => {
  const [apiKey, setApiKey] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { login } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    try {
      const result = await login(apiKey);
      if (result.success) {
        // Login successful - AuthContext will handle state update
        // No need for manual redirect, App.js will re-render automatically
      } else {
        setError(result.error || 'Login failed');
      }
    } catch (err) {
      // Handle specific error messages from the backend
      let errorMessage = '';

      if (err.message) {
        // Check if it's a JSON error response from the backend
        if (err.message.includes('HTTP error! status:') && err.message.includes('"detail"')) {
          try {
            // Extract the detail from the JSON response
            const startIndex = err.message.indexOf('"detail":"') + '"detail":"'.length;
            const endIndex = err.message.indexOf('"}', startIndex);

            if (startIndex !== -1 && endIndex !== -1) {
              errorMessage = err.message.substring(startIndex, endIndex);
              // Remove any escaped quotes
              errorMessage = errorMessage.replace(/\\"/g, '"');
            } else {
              // If we can't extract the detail, use a generic message
              errorMessage = 'An error occurred during login. Please try again.';
            }
          } catch (parseErr) {
            errorMessage = 'An error occurred during login. Please try again.';
          }
        } else {
          errorMessage = err.message;
        }
      } else {
        errorMessage = 'An error occurred during login. Please try again.';
      }

      setError(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
            🔐 Codebase Analyzer
          </h2>
          <p className="mt-2 text-center text-sm text-gray-600">
            Sign in with your API key to continue
          </p>
        </div>
        <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
          <input type="hidden" name="remember" defaultValue="true" />
          <div className="rounded-md shadow-sm -space-y-px">
            <div>
              <label htmlFor="api-key" className="sr-only">
                X-API Key
              </label>
              <input
                id="api-key"
                name="api-key"
                type="password"
                autoComplete="current-password"
                required
                value={apiKey}
                onChange={(e) => setApiKey(e.target.value)}
                className="appearance-none rounded-none relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 rounded-t-md focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 focus:z-10 sm:text-sm"
                placeholder="Enter your X-API Key"
              />
            </div>
          </div>

          {error && (
            <div className="rounded-md bg-red-50 p-4">
              <div className="flex">
                <div className="ml-3">
                  <h3 className="text-sm font-medium text-red-800">{error}</h3>
                </div>
              </div>
            </div>
          )}

          <div>
            <button
              type="submit"
              disabled={isLoading}
              className="group relative w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:opacity-50"
            >
              {isLoading ? 'Signing in...' : 'Sign in'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default LoginPage;